/* eslint-disable unicorn/no-nested-ternary, project-structure/folder-structure */
import React from 'react';
import {
  arrayOf,
  bool,
  oneOfType,
  string,
  node,
  func,
  shape,
} from 'prop-types';
import { connect } from 'react-redux';
import { Suspense } from '@axiom/ui';

import { Banner } from '../components/Banner/Banner';
import { Header } from '../components/Header/Header';
import AppErrors from '../components/AppErrors/AppErrors';
import LoadingTreatment from '../components/LoadingTreatment/LoadingTreatment';
import { hasInitialDataSelector } from '../redux/selectors/app';

import { ErrorBoundaryLayout } from './ErrorBoundaryLayout/ErrorBoundaryLayout';
import { AppDetailWrapper, DetailWrapper, DetailArea } from './styles';

const DetailComponent = ({
  wide,
  apiErrors,
  children,
  hasInitialData,
  showGreyBackground,
  user,
}) => (
  <AppDetailWrapper>
    {hasInitialData && user ? (
      <>
        <AppErrors />
        <Header closeSideDrawer={() => {}} user={user} />
        <Suspense fallback={null}>
          <Banner />
        </Suspense>
        <DetailWrapper data-test="DETAIL_WRAPPER" wide={wide}>
          <DetailArea
            data-test="DETAIL_AREA"
            showGreyBackground={showGreyBackground}
          >
            {children}
          </DetailArea>
        </DetailWrapper>
      </>
    ) : apiErrors.some(error => !!error) ? (
      <ErrorBoundaryLayout />
    ) : (
      <LoadingTreatment maxLoadMilliseconds={30000} />
    )}
  </AppDetailWrapper>
);

DetailComponent.defaultProps = {
  wide: false,
  apiErrors: [],
  hasInitialData: false,
  children: null,
  showGreyBackground: false,
  user: null,
};

DetailComponent.propTypes = {
  apiErrors: arrayOf(shape({})),
  children: oneOfType([string, node, func]),
  hasInitialData: bool,
  showGreyBackground: bool,
  user: shape({
    activeDirectorySecurityGroup: string,
  }),
  wide: bool,
};
// HMR does not work well with composition function, need to split these
// into their own variables so they can be replaced by updates.
const ConnectHOC = connect(hasInitialDataSelector);
export default ConnectHOC(DetailComponent);
